/**
 * Răspuns pentru GET /dashboard/vessel-departures.
 * Import: top 4 POL × 2 plecări. Export: un grup ROCND cu următoarele 8 plecări (bound S).
 */
export interface VesselDepartureItem {
  vesselName: string;
  vesselCode: string;
  /** ISO string sau null — ETD din POL. */
  etd: string | null;
  /** Cod port plecare (POL). */
  from: string;
  /** Cod port de transshipment (default TRIST = Istanbul). */
  transshipmentPort: string;
  /** ISO string sau null — ETA la TRIST. */
  transshipmentEta: string | null;
  /** Cod port final (default ROCND = Constanța). */
  finalPort: string;
  service: string;
}

export interface PortDeparturesRow {
  portCode: string;
  portName: string;
  departures: VesselDepartureItem[];
}

export const EMPTY_VESSEL_DEPARTURES: PortDeparturesRow[] = [];
